"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var message_pipe_1 = require("../provider/pipes/message.pipe");
var material_module_1 = require("./material.module");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var message_placeholder_replacer_pipe_1 = require("../provider/pipes/message-placeholder-replacer.pipe");
var basic_shared_module_1 = require("./basic-shared.module");
var SharedModule = /** @class */ (function () {
    /**
     * import all common declarations and providers,
     * and import shared module in login module, shell module
     */
    function SharedModule() {
    }
    SharedModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule, material_module_1.MaterialModule, idm_message_language_service_client_js_1.LanguageUtilsModule, basic_shared_module_1.BasicSharedModule],
            exports: [common_1.CommonModule, message_pipe_1.MessagePipe, message_placeholder_replacer_pipe_1.MessagePlaceholderReplacerPipe, material_module_1.MaterialModule, idm_message_language_service_client_js_1.LanguageUtilsModule]
        })
        /**
         * import all common declarations and providers,
         * and import shared module in login module, shell module
         */
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;
//# sourceMappingURL=shared.module.js.map